export default "/fonts/vendor/mdui/dist/roboto/Roboto-Black.woff?82ada96d1354cece118ce4ba73cea813";